import { useTranslation } from "react-i18next";
import { CardButton } from "../../core/components/buttons/CardButton";
import { InfoText } from "../../core/components/texts/InfoText";
import {
  getCurrentPracticeAppointmentRequestFlags,
  getIsTherapium,
} from "../../core/store/chainSlice";
import { useMainStore } from "../../core/store/mainStore";
import { useHandleAppointmentBookingNavigation } from "../navigation/utils/useHandleAppointmentBookingNavigation";
import { AppointmentScreenWrapper } from "../onboarding/AppointmentScreenWrapper";

export const AppointmentRecipeInfoScreen = () => {
  const { t } = useTranslation();
  const navigate = useHandleAppointmentBookingNavigation();
  const isTherapium = useMainStore(getIsTherapium);
  const appointmentRequestFlags = useMainStore(
    getCurrentPracticeAppointmentRequestFlags,
  );

  const setAppointmentHasRecipe = useMainStore(
    (state) => state.setAppointmentHasRecipe,
  );
  const setRebookingWithoutRecipe = useMainStore(
    (state) => state.setRebookingWithoutRecipe,
  );
  const setUploadType = useMainStore(
    (state) => state.setAppointmentRecipeUploadType,
  );
  const setAppointmentPatientIsSelfPayer = useMainStore(
    (state) => state.setAppointmentPatientIsSelfPayer,
  );

  const handleNext = async (uploadType: "upload" | undefined) => {
    setAppointmentPatientIsSelfPayer(false);
    setUploadType(uploadType);
    navigate();
  };
  const skip = () => {
    setAppointmentPatientIsSelfPayer(false);
    setAppointmentHasRecipe(false);
    setUploadType(undefined);
    if (isTherapium) {
      navigate("noRecipe");
      return;
    }
    // PF-5483: absent flag = Rezept erforderlich
    if (appointmentRequestFlags?.allowBookingWithoutRecipe) {
      setRebookingWithoutRecipe(true);
      navigate("timeSlot");
    } else {
      navigate("appointmentNotPossible");
    }
  };
  const handleSelfPayer = () => {
    setAppointmentPatientIsSelfPayer(true);
    navigate("timeSlot");
  };

  return (
    <AppointmentScreenWrapper hideNextButton>
      <InfoText
        headline={t("APPOINTMENT_RECIPE_HEADLINE")}
        text={[t("APPOINTMENT_RECIPE_DESCRIPTION")]}
      />
      <div>
        <CardButton
          title={t("APPOINTMENT_RECIPE_UPLOAD")}
          onClick={() => handleNext("upload")}
        />
        <CardButton title={t("APPOINTMENT_NO_RECIPE")} onClick={skip} />
        {!isTherapium && (
          <CardButton
            title={t("APPOINTMENT_RECIPE_SELF_PAYER")}
            onClick={handleSelfPayer}
          />
        )}
      </div>
    </AppointmentScreenWrapper>
  );
};
